import * as React from 'react';
import * as classnames from 'classnames/bind';
import _get from 'lodash/get';
import {observer} from 'mobx-react';
import {action, observable} from 'mobx';
import {IWidgetComponentProps} from '@mintdata-wsp/wsp/ui/views/visualDesigner/flow/panels/properties/widgets/FlowPropertiesWidgets';
import {CloudEnumEntry} from '@mintdata-wsp/common/state/ui/visualDesigner/VisualDesignerState';
import {PropertyError} from '@mintdata-wsp/wsp/ui/views/visualDesigner/flow/panels/properties/widgets/common/PropertyError';
import {Suggest} from '@mintdata/mint-kit/impl/properties/components/suggest/Suggest';
import {IItemRendererProps} from '@mintdata/mint-kit/impl/properties/components/suggest/common/ListItemsProps';
import {QueryListUtils} from '@mintdata/mint-kit/impl/properties/components/suggest/QueryListUtils';
import {IInputEditProps} from '@mintdata/mint-kit/impl/properties/components/inputEdit/InputEdit';

const styles = require('@mintdata/mint-kit/impl/properties/components/suggest/QueryList.less');
const cx = classnames.bind(styles);

export interface ISuggestWidgetProps extends IWidgetComponentProps
{
    isEditable?:boolean;
}

@observer
export class SuggestWidget extends React.Component<ISuggestWidgetProps, any>
{
    @observable
    private isDirty:boolean;

    public static defaultProps:Partial<ISuggestWidgetProps> = {
        isOutlined: true,
        isEditable: false,
    };

    constructor(props:IWidgetComponentProps)
    {
        super(props);

        const {isDirty} = props;

        this.isDirty = (isDirty !== undefined) ? isDirty : false;
    }

    @action
    componentWillReceiveProps({isDirty}:IWidgetComponentProps)
    {
        if( isDirty !== undefined )
        {
            this.isDirty = isDirty;
        }
    }

    render()
    {
        const {
            prop,
            inlineLabel,
            isOutlined,
            isEditable,
            error,
            onRef,
        } = this.props;

        const {value, definition} = prop;
        const {enumValues} = definition;

        const items = enumValues.entries;
        const selectedItem = items.find((item:CloudEnumEntry) => item.value === value) ||
            new CloudEnumEntry(value, value);

        const errors = this.isDirty ? _get(error, 'messages', []) : [];

        const inputProps:Partial<IInputEditProps> = {
            label: inlineLabel,
            isOutlined,
            isInvalid: errors.length > 0,
            validationError: errors[0],
            onRef,
        };

        const itemToInputValue = (item:CloudEnumEntry) => item.caption;
        const inputValueToItem = (inputValue:string) =>
        {
            const found = items.find((item:CloudEnumEntry) => item.caption === inputValue);

            return found || new CloudEnumEntry(inputValue, inputValue);
        };

        const EnumSuggest = Suggest.ofType<CloudEnumEntry>();

        return (
            <div>
                <EnumSuggest
                    items={items}
                    selectedItem={selectedItem}
                    onItemSelect={this._handleItemSelect}
                    inputProps={inputProps}
                    itemToInputValue={itemToInputValue}
                    inputValueToItem={inputValueToItem}
                    itemRenderer={this._itemRenderer}
                    itemListPredicate={this._itemListPredicate}
                    isEditable={isEditable}
                />
            </div>
        );
    }

    private _itemListPredicate = (query:string, items:CloudEnumEntry[]) =>
    {
        return items.filter((item) => (
            item.caption.toLowerCase().indexOf(query.toLowerCase()) >= 0
        ));
    };

    private _itemRenderer = (item:CloudEnumEntry, itemProps:IItemRendererProps) =>
    {
        const {handleClick, modifiers, query} = itemProps;
        const {active} = modifiers;

        return (
            <div
                className={cx(styles.listItem, {listItemActive: active})}
                key={item.value}
                onMouseDown={handleClick}
            >
                <div className={styles.listItemText}>{QueryListUtils.highlightText(item.caption, query)}</div>
            </div>
        );
    };

    @action
    private _handleItemSelect = (item:CloudEnumEntry) =>
    {
        const {onChange, isDirty} = this.props;

        onChange(item.value);

        if( isDirty === undefined )
        {
            this.isDirty = true;
        }
    };
}
